import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import myBootstrap from '../src/assets/js/core/bootstrap.bundle.min.js'
import mypopper from '../src/assets/js/core/popper.min.js';
// import myperfect from './src/assets/js/plugins/perfect-scrollbar.min.js';
// import mysmooth from './src/assets/js/plugins/smooth-scrollbar.min.js';
// import mychartjs from './src/assets/js/plugins/chartjs.min.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
